export const GRAPH_DATE_FORMAT = "MMM D";
